import React, {FC} from 'react';

import classNames from 'classnames';

import {useSelector} from 'react-redux';

import {useFeature} from 'components/feature';

import {getAllStepsStatuses} from '../../store/selectors/currentStep/currentStep';
import {CartConnected} from '../cart/cart';
import {CartItemFaceliftSkeleton} from '../cartItemFacelift/cartItemFaceliftSkeleton/cartItemFaceliftSkeleton';
import {PointsInfo} from '../pointsInfo/pointsInfo';

import s from './sidebar.scss';

/**
 * SideBar for checkout
 *
 * @constructor
 */
export const Sidebar: FC = () => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const status = useSelector(getAllStepsStatuses);

    return (
        <section
            aria-label="Sidebar cart info"
            className={classNames(s.container, {[s.wrapperFacelift]: isFacelift})}
        >
            <div className={classNames(s.stickWrap, {[s.wrapperFacelift]: isFacelift})}>
                {isFacelift && !status.deliveryStep.loaded ? (
                    <CartItemFaceliftSkeleton />
                ) : (
                    <CartConnected />
                )}
                <PointsInfo />
            </div>
        </section>
    );
};

Sidebar.displayName = 'Sidebar';
